export default __webpack_public_path__ + "static/media/Home_Black.d9c7007c.svg";